import { useEffect, useRef, useState } from 'react';
import { LogOut } from 'lucide-react';
import { logoutCurrentUser, userDisplayName, type AuthUser } from './auth-api';

export default function AccountNav({ user, officeUrl }: {
  user: AuthUser | null;
  officeUrl: string;
}) {
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const rootRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return;
    const closeOnOutside = (event: MouseEvent) => {
      if (!rootRef.current?.contains(event.target as Node)) setOpen(false);
    };
    const closeOnEscape = (event: KeyboardEvent) => {
      if (event.key === 'Escape') setOpen(false);
    };
    document.addEventListener('mousedown', closeOnOutside);
    document.addEventListener('keydown', closeOnEscape);
    return () => {
      document.removeEventListener('mousedown', closeOnOutside);
      document.removeEventListener('keydown', closeOnEscape);
    };
  }, [open]);

  const logout = async () => {
    setBusy(true);
    try { await logoutCurrentUser(); }
    finally { setBusy(false); setOpen(false); }
  };

  return <div className="site-account-nav" ref={rootRef}>
    <button type="button" className="login-link account-link account-trigger" aria-haspopup="menu" aria-expanded={open} onClick={() => setOpen((value) => !value)}>
      {userDisplayName(user)}
    </button>
    {open && <div className="site-account-menu" role="menu">
      <a href={officeUrl} role="menuitem">进入工作区</a>
      <button type="button" role="menuitem" disabled={busy} onClick={() => void logout()}><LogOut/>{busy ? '正在退出…' : '退出登录'}</button>
    </div>}
  </div>;
}
